/* eslint-disable react/prop-types */
import { useContext, useEffect, useState } from 'react';
import { Table } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import tableTypes from '../../../../utils/filesTableTypes';
import { FilesSdsPtContext } from '../../../../context/FilesSdsPtContext';
import { formatDate } from '../../../../utils/formatUtils';
import ButtonHeader from '../../../../page/ServiceRequest/DetailServiceRequest/TabsDetail/FilesDetailServiceRequest/Table/ButtonHeader/ButtonHeader';
import { DetailRequest, DetailRequestMonthly } from '../../../../utils/globalPropTypes';
import { getFilesDownloadOptions } from '../../../../services/workReport';

const TableFiles = (props) => {
  const {
    details,
    onlyButtonDeletedFiles,
    isMonthly,
    type,
    id,
    disabledButtonDownloadDelete,
    permissions
  } = props;

  const { dataFilesPt, getDataFilesPt, setInfoCompleteSelect } = useContext(FilesSdsPtContext);

  const [select, setSelect] = useState([]);
  const [downloadOptions, setDownloadOptions] = useState([]);

  const selectTableFiles = () => {
    if (type === tableTypes.pt) return dataFilesPt;

    return [];
  };

  const selectAll = () => {
    const tableFiles = selectTableFiles();

    if (select.length < tableFiles.length) {
      const ids = tableFiles.map((item) => item.id);

      setSelect(ids);
    } else {
      setSelect([]);
    }
  };

  const handleChangeSelect = (item) => {
    if (select.includes(item)) {
      const newSelect = select.filter((name) => name !== item);

      setSelect(newSelect);

      return;
    }
    setSelect([...select, item]);
  };

  const justify = {
    textAlign: 'center',
    padding: 20
  };

  const sizeFile = ({ value }) => {
    const valueMb = Math.round(value / 1024);

    return `${valueMb} kb`;
  };

  const columnsPt = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataFilesPt.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuario',
      hideSort: true,
      style: justify
    },
    {
      Header: 'Pos./Lin - Fecha',
      accessor: 'linea',
      hideSort: true,
      style: justify
    }
  ];

  const columnsPtMonthly = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataFilesPt.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuario',
      hideSort: true,
      style: justify
    },
    {
      Header: 'Ubicación',
      accessor: 'ubicacion',
      hideSort: true,
      style: justify
    },
    {
      Header: 'Pos./Lin - Fecha',
      accessor: 'linea',
      hideSort: true,
      style: justify
    }
  ];

  const getColumnsCustom = () => {
    let columnsPrimary = [];

    if (isMonthly) {
      columnsPrimary = columnsPtMonthly;
    } else {
      columnsPrimary = columnsPt;
    }

    return columnsPrimary;
  };

  useEffect(() => {
    let dataFiles = [];

    if (type === tableTypes.pt) dataFiles = dataFilesPt;
    if (dataFiles?.length) {
      const completeInfo = dataFiles?.filter((item) => select.includes(item.id));

      setInfoCompleteSelect(completeInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [select]);

  useEffect(() => {
    getDataFilesPt(id, details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getOptions = async () => {
      const options = await getFilesDownloadOptions();

      setDownloadOptions(options.sort((a, b) => a.id - b.id));
    };

    getOptions();
  }, []);

  return (
    <div>
      <ButtonHeader
        approver
        attachedFiles={dataFilesPt}
        details={details}
        disabledButtonDownloadDelete={disabledButtonDownloadDelete}
        downloadOptions={downloadOptions}
        onlyButtonDeletedFiles={onlyButtonDeletedFiles}
        permissions={permissions}
        sds={false}
        select={select}
        setSelect={setSelect}
        type={type}
        // disableButtonSDSCancelled={disableButtonSDSCancelled}
      />
      <div>
        <Table
          // columns={columnSds ? columns : columnsPt}
          borderless
          columns={getColumnsCustom()}
          data={dataFilesPt}
          type="light"
        />
      </div>
    </div>
  );
};

export default TableFiles;

TableFiles.propTypes = {
  type: PropTypes.oneOf([
    tableTypes.pt,
    tableTypes.sds,
    tableTypes.inactivePT,
    tableTypes.inactiveSDS
  ]).isRequired,
  permissions: PropTypes.shape({
    delete: PropTypes.bool,
    download: PropTypes.bool,
    upload: PropTypes.bool
  }),
  onlyButtonDeletedFiles: PropTypes.bool.isRequired,
  disabledButtonDownloadDelete: PropTypes.bool.isRequired,

  details: PropTypes.oneOfType([DetailRequest, DetailRequestMonthly]).isRequired,
  isMonthly: PropTypes.bool,
  id: PropTypes.number.isRequired
};

TableFiles.defaultProps = {
  permissions: {
    delete: false,
    download: true,
    upload: false
  },
  isMonthly: false
};
